import { api } from './api';

export interface PersonType {
  id: string | number;
  code: string;
  name: string;
  beschreibung?: string | null;
  aktiv: boolean;
  sort_order?: number;
}

export const personTypesApi = {
  list: async (): Promise<PersonType[]> => {
    const items = await api.get<PersonType[]>('/api/personentypen');
    return Array.isArray(items) ? items : [];
  },
  create: async (payload: Partial<PersonType>): Promise<PersonType> => {
    return api.post<PersonType>('/api/personentypen', payload);
  },
  update: async (id: string | number, payload: Partial<PersonType>): Promise<PersonType> => {
    return api.put<PersonType>(`/api/personentypen/${id}`, payload);
  },
  delete: async (id: string | number): Promise<{ message?: string }> => {
    return api.delete<{ message?: string }>(`/api/personentypen/${id}`);
  }
};


